var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFreezingRain = function SvgFreezingRain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.54 4.342C8.843 3.444 10.324 3 11.947 3c1.993 0 3.732.636 5.156 1.924 1.211 1.096 1.93 2.427 2.12 3.96a4.97 4.97 0 0 1 2.357 1.362M7.54 4.342c-1.144.785-1.971 1.801-2.46 3.033A5.7 5.7 0 0 0 2.3 9.163C1.443 10.169 1 11.344 1 12.65c0 .79.163 1.54.502 2.23a.995.995 0 1 0 1.786-.876 3 3 0 0 1-.299-1.354c0-.82.266-1.54.826-2.198.555-.652 1.28-1.077 2.222-1.267a1 1 0 0 0 .755-.688c.31-1.029.92-1.862 1.873-2.516l.001-.001c.958-.659 2.042-.992 3.282-.992 1.535 0 2.788.476 3.821 1.41 1.03.931 1.517 2.021 1.517 3.325 0 .51.385.937.892.99.824.085 1.467.396 1.979.921v.001c.515.526.747 1.1.747 1.77 0 .728-.266 1.334-.86 1.871a.995.995 0 1 0 1.335 1.476c.992-.897 1.515-2.031 1.515-3.347 0-1.213-.453-2.28-1.312-3.16",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.95 11.492c.53.144.843.69.7 1.22l-1.92 7.072a.995.995 0 1 1-1.92-.521l1.92-7.072a.995.995 0 0 1 1.22-.699",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.446 12.683a.995.995 0 0 1 1.407.004l5.163 5.198a.995.995 0 1 1-1.41 1.402L4.44 14.089a.995.995 0 0 1 .005-1.406",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.233 14.797a.995.995 0 0 1-.708 1.215L4.44 17.884a.995.995 0 1 1-.508-1.923l7.084-1.872a.995.995 0 0 1 1.216.707M14.939 13.976a.995.995 0 0 1 .717 1.21l-1.527 5.974a.995.995 0 1 1-1.928-.493l1.528-5.974a.995.995 0 0 1 1.21-.717M18.255 13.97c.535.123.87.657.746 1.192l-.691 3.003a.995.995 0 0 1-1.939-.446l.691-3.003a.995.995 0 0 1 1.193-.746",
    clipRule: "evenodd"
  })));
};
export default SvgFreezingRain;